import script from "./ModalMixin.vue?vue&type=script&lang=ts"
export * from "./ModalMixin.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__